var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"dish"},[_c('router-view',{staticClass:"dish__data",attrs:{"userRestaurants":_vm.userRestaurants}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }